import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OrderOptimizerOverviewComponent } from './order-optimizer-overview.component';

const routes: Routes = [{ path: '', component: OrderOptimizerOverviewComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OrderOptimizerOverviewRoutingModule { }
